import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiProfileQueryResponse,
  GetApiProfileQueryParams,
  GetApiProfile401,
  GetApiProfile403,
} from "../../../types/GetApiProfile";

export function getGetApiProfileUrl() {
  return `/api/Profile` as const;
}

/**
 * {@link /api/Profile}
 */
export async function getApiProfile(
  params?: GetApiProfileQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiProfileQueryResponse,
    ResponseErrorConfig<GetApiProfile401 | GetApiProfile403>,
    unknown
  >({
    method: "GET",
    url: getGetApiProfileUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
